import { useSelector, shallowEqual } from 'react-redux';

import {
  selectPsrPreferences,
  selectPsrPreferencesArr
} from 'state/psr/psr-slice';

export const usePsr = () => {
  const psrPreferences = useSelector(selectPsrPreferences, shallowEqual);
  const psrPreferencesArr = useSelector(selectPsrPreferencesArr, shallowEqual);

  const hasPsr = !!psrPreferencesArr.length;
  const psrPayload = Object.entries(psrPreferences).reduce(
    (acc, [key, value]) => {
      return {
        ...acc,
        [key]: value?.map(({ code, subCode, expiryDate }) => ({
          code,
          ...(subCode && { subCode }),
          ...(expiryDate && { expiryDate })
        }))
      };
    },
    {}
  );

  const psr = {
    ...psrPayload,
    serviceNeedConsent: hasPsr
  };

  return hasPsr ? { psr } : {};
};
